<template>
  <div class="gift-about">
    <div class="about-cards">
      <div class="about-commom-quetions">Dúvidas frequentes</div>
      <section>
        <b-collapse class="card" animation="slide" aria-id="faq" :open="false">
          <template #trigger="props">
            <div
              class="card-header"
              role="button"
              aria-controls="faq"
              :aria-expanded="props.open"
            >
              <p class="card-header-title">
                Por que devo escolher a lista de casamento do Casar.com?
              </p>
              <a class="card-header-icon">
                <img :src="props.open ? menuUp : menuDown" />
              </a>
            </div>
          </template>

          <div class="card-content">
            <div class="card-text-style">
              A lista de casamento do Casar.com é a mais completa e flexível!
              Temos diversas opções de listas prontas e sugestões de presentes
              já criados para facilitar a edição.<br /><br />

              Além disso, todos os presentes ganhos viram saldo na Carteira, e aí é só resgatar via PIX, com transferências gratuitas e ilimitadas.<br /><br />

              E tem mais! Com a lista de casamento do Casar.com vocês garantem a
              melhor taxa do mercado ({{ taxaTransacao }}).
            </div>
          </div>
        </b-collapse>

        <b-collapse class="card" animation="slide" aria-id="faq" :open="false">
          <template #trigger="props">
            <div
              class="card-header"
              role="button"
              aria-controls="faq"
              :aria-expanded="props.open"
            >
              <p class="card-header-title">
                O presente continua na lista após comprado?
              </p>
              <a class="card-header-icon">
                <img :src="props.open ? menuUp : menuDown" />
              </a>
            </div>
          </template>

          <div class="card-content">
            <div class="card-text-style">
              Como os presentes são fictícios e convertidos em dinheiro, eles
              continuarão disponíveis na lista de presentes de vocês, podendo
              ser comprados novamente por outros convidados.<br /><br />

              Caso queiram que o presente saia da lista depois de comprado, é
              possível excluí-lo manualmente.<br />
            </div>
          </div>
        </b-collapse>

        <b-collapse class="card" animation="slide" aria-id="faq" :open="false">
          <template #trigger="props">
            <div
              class="card-header"
              role="button"
              aria-controls="faq"
              :aria-expanded="props.open"
            >
              <p class="card-header-title">
                Como funciona a lista de presentes em dinheiro?
              </p>
              <a class="card-header-icon">
                <img :src="props.open ? menuUp : menuDown" />
              </a>
            </div>
          </template>

          <div class="card-content">
            <div class="card-text-style">
              1° Vocês criam uma lista de presentes fictícios e a compartilham
              com os convidados.<br /><br />

              2° Os convidados acessam o site de vocês e realizam a compra dos
              presentes.<br /><br />

              3° O valor fica disponível na carteira de vocês, conforme prazos 
              e taxas contratados. <br /><br />

              4° Vocês solicitam a transferência por PIX para conta bancária.<br />
            </div>
          </div>
        </b-collapse>

        <b-collapse class="card" animation="slide" aria-id="faq" :open="false">
          <template #trigger="props">
            <div
              class="card-header"
              role="button"
              aria-controls="faq"
              :aria-expanded="props.open"
            >
              <p class="card-header-title">
                Qual é a taxa da lista de presentes de casamento?
              </p>
              <a class="card-header-icon">
                <img :src="props.open ? menuUp : menuDown" />
              </a>
            </div>
          </template>

          <div class="card-content">
            <div class="card-text-style">
              Temos uma taxa única de {{ taxaTransacao }} por presente, ela pode
              ser paga por vocês ou repassada aos convidados. <br /><br />

              Se vocês optarem por repassar a taxa para os convidados, ela será
              embutida no valor dos seus presentes e o convidado verá apenas o
              valor total.<br /><br />

              Para escolher quem irá pagar a taxa da lista, clique em
              “Configurar lista”.
            </div>
          </div>
        </b-collapse>

        <b-collapse class="card" animation="slide" aria-id="faq" :open="false">
          <template #trigger="props">
            <div
              class="card-header"
              role="button"
              aria-controls="faq"
              :aria-expanded="props.open"
            >
              <p class="card-header-title">
                Como eu resgato/saco os valores em dinheiro?
              </p>
              <a class="card-header-icon">
                <img :src="props.open ? menuUp : menuDown" />
              </a>
            </div>
          </template>

          <div class="card-content">
            <div class="card-text-style">
              Resgate por meio de um PIX, é simples, rápido e seguro! Lembrando
              que o saque PIX é gratuito e ilimitado.<br /><br />

              Para realizar o saque, clique na área “carteira” no menu superior
              do seu site. Depois cadastre e valide as informações de
              recebimento PIX do casal, conforme orientado pelo site.<br /><br />

              Após a validação das chaves PIX, basta clicar em "utilizar saldo"
              dentro da carteira, selecionar a forma de resgate via PIX e
              prosseguir com a confirmação do saque.
            </div>
          </div>
        </b-collapse>

        <b-collapse class="card" animation="slide" aria-id="faq" :open="false">
          <template #trigger="props">
            <div
              class="card-header"
              role="button"
              aria-controls="faq"
              :aria-expanded="props.open"
            >
              <p class="card-header-title">
                Quanto tempo eu tenho para resgatar o saldo da minha lista de
                presentes?
              </p>
              <a class="card-header-icon">
                <img :src="props.open ? menuUp : menuDown" />
              </a>
            </div>
          </template>

          <div class="card-content">
            <div class="card-text-style">
              Vocês possuem até um ano após a data do casamento para resgatar os
              presentes recebidos.
            </div>
          </div>
        </b-collapse>

        <b-collapse class="card" animation="slide" aria-id="faq" :open="false">
          <template #trigger="props">
            <div
              class="card-header"
              role="button"
              aria-controls="faq"
              :aria-expanded="props.open"
            >
              <p class="card-header-title">
                Quanto tempo antes devo fazer a lista de presente de casamento?
              </p>
              <a class="card-header-icon">
                <img :src="props.open ? menuUp : menuDown" />
              </a>
            </div>
          </template>

          <div class="card-content">
            <div class="card-text-style">
              Não há regras! Vocês podem criar o site gratuitamente quando
              desejarem e já começar a edição! Ele ficará no ar desde o momento
              da criação até 30 dias após o casamento.
            </div>
          </div>
        </b-collapse>

        <b-collapse class="card" animation="slide" aria-id="faq" :open="false">
          <template #trigger="props">
            <div
              class="card-header"
              role="button"
              aria-controls="faq"
              :aria-expanded="props.open"
            >
              <p class="card-header-title">
                Irei receber uma notificação quando um convidado comprar um
                presente?
              </p>
              <a class="card-header-icon">
                <img :src="props.open ? menuUp : menuDown" />
              </a>
            </div>
          </template>

          <div class="card-content">
            <div class="card-text-style">
              Sim! Ao receber um novo presente vocês serão notificados por
              e-mail! Além disso, dentro do site, é possível acompanhar todos os
              presentes recebidos, ter as informações das compras, ver os
              recados deixados pelos convidados e também é possível agradecer
              pelos presentes.
            </div>
          </div>
        </b-collapse>
      </section>
      <div style="text-align: center">
        <div class="about-more-questions-label">Ficou com alguma dúvida?</div>
        <div class="about-more-questions-text">
          Acesse a nossa FAQ e tire todas as suas dúvidas sobre a nossa lista de
          presente, ou se preferir,<br />
          entre em contato com o nosso time de especialistas via chat.
        </div>
        <a
          title="Suporte Casar.com"
          href="https://ajuda.casar.com/support/home"
          target="_blank"
          class="button is-primary"
        >
          Acessar FAQ
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import menuUp from '@/assets/img/chevron-up.svg'
import menuDown from '@/assets/img/chevron-down.svg'

export default {
  data() {
    return {
      menuUp,
      menuDown,
      isOpen: 0,
    }
  },

  mounted() {},
  components: {},

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },
    taxaTransacao() {
      const tax =
        this.$store.state.app.wedSiteInfo?.presente_config
          ?.virtual_taxa_transacao_customizada

      return tax ? tax.toString().replace('.', ',') + '%' : ''
    },
  },

  methods: {},
}
</script>

<style lang="scss" scoped>
.gift-about {
  text-align: center;
}

.about-commom-quetions {
  color: $primary;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 24px;
  text-align: left;
}

.card-text-style {
  margin-left: 20px;
  text-align: left;
}

.about-cards {
  width: 80%;
  display: inline-block;
  margin-top: 40px;
  margin-bottom: 20px;
}

.about-more-questions-label {
  font-size: 18px;
  font-weight: 700;
  color: $primary;
  margin-top: 48px;
  text-align: center;
}

.about-more-questions-text {
  font-size: 16px;
  font-weight: 400;
  color: $neutral;
  margin-bottom: 32px;
  text-align: center;
}
</style>
